import { generateNodeId } from "@/components/conversation-renderer/conversation-renderer-util";
import { IntentLocale } from "@/locales/localeid";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import { Form, Input, Modal, Radio, Select } from "ant-design-vue";
import { WrappedFormUtils } from "ant-design-vue/types/form/form";
import { has } from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { intentNameLengthValidator, intentNameValidator, intentUniqueValidator } from ".";
import { NormalizeSpaces } from "../../conversation-builder-util";
import { Intent, IntentType } from "../../models/intent.model";

@Component({
	components: {
		Modal,
		Form,
		FormItem: Form.Item,
		Radio,
		RadioGroup: Radio.Group,
		Input,
		Select,
		SelectOption: Select.Option
	}
})
export default class IntentAddDialog extends Vue {
	public IntentType = IntentType;
	public IntentLocale = IntentLocale;

	public visible: boolean = false;
	public form!: WrappedFormUtils;

	private conversationStore = getModule(ConversationBuilderState);

	public intentNameValidator?: Function;
	public intentNameLengthValidator?: Function;
	public intentUniqueValidator?: Function;

	created() {}

	private init() {
		this.intentNameValidator = intentNameValidator;
		this.intentNameLengthValidator = intentNameLengthValidator;
		this.intentUniqueValidator = intentUniqueValidator();
		this.form = this.$form.createForm(this, {
			name: "intent-add-dialog",
			onValuesChange: this.onValuesChange
		});
	}

	public get commonIntentDirectory() {
		return this.conversationStore.commonIntents.directory;
	}
	public get intentDirectory() {
		return this.conversationStore.intents.directory;
	}

	private onValuesChange(props: WrappedFormUtils, fields: Partial<IFormValues>) {
		if (has(fields, "type")) {
			this.form.setFieldsValue({
				intentNew: undefined,
				intentExisting: undefined,
				intentCommon: undefined
			});
		}
	}

	public submit() {
		this.form.validateFields((err) => {
			if (err) {
				return;
			}
			const formValues = this.form.getFieldsValue() as IFormValues;
			if (formValues.type === IntentType.New) {
				const intent: Intent = {
					id: generateNodeId(),
					name: NormalizeSpaces(formValues.intentNew),
					order: 0,
					key: 0,
					utterances: []
				};
				this.conversationStore.addIntent(intent);
				this.$emit("create", intent);
			}
			if (formValues.type === IntentType.Existing) {
				const intent = this.conversationStore.intents.directory[formValues.intentExisting];
				this.$emit("create", intent);
			}

			if (formValues.type === IntentType.Common) {
				const commonIntent = this.conversationStore.commonIntents.directory[formValues.intentCommon];
				this.conversationStore.addIntent({
					...commonIntent,
					commonIntentId: commonIntent.id,
					key: 0,
					order: 0,
					utterances: commonIntent.utterances.map((utterance) => ({ ...utterance, key: 0, order: 0 }))
				});
				if (commonIntent.entityId) {
					const commonEntity = this.conversationStore.commonEntites.directory[commonIntent.entityId];
					this.conversationStore.addEntity({
						...commonEntity,
						commonEntityId: commonEntity.id,
						key: 0
					});
				}
				const intent = this.conversationStore.intents.directory[commonIntent.id];
				this.$emit("create", intent);
			}

			this.close();
		});
	}

	public open() {
		this.visible = true;
		this.init();
	}
	public close() {
		this.visible = false;
	}
}

interface IFormValues {
	type: IntentType;
	intentNew: string;
	intentExisting: string;
	intentCommon: string;
}
